import { render, staticRenderFns } from "./DashboardRankingPadrillos.vue?vue&type=template&id=53ce81e5&scoped=true"
import script from "./DashboardRankingPadrillos.vue?vue&type=script&lang=js"
export * from "./DashboardRankingPadrillos.vue?vue&type=script&lang=js"
import style0 from "./DashboardRankingPadrillos.vue?vue&type=style&index=0&id=53ce81e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ce81e5",
  null
  
)

export default component.exports